import { render, staticRenderFns } from "./JustImageSettings.vue?vue&type=template&id=1242b338&scoped=true&"
import script from "./JustImageSettings.vue?vue&type=script&lang=js&"
export * from "./JustImageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242b338",
  null
  
)

export default component.exports